import axios from "axios";
import { API } from "@/lib/api";

const TOKEN_KEY = "gca_pro_token";
const USER_KEY = "gca_pro_user";

export const proApi = axios.create({ baseURL: API });
proApi.interceptors.request.use((config) => {
  const token = localStorage.getItem(TOKEN_KEY);
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

export const setProAuth = (token, user) => {
  localStorage.setItem(TOKEN_KEY, token);
  localStorage.setItem(USER_KEY, JSON.stringify(user || {}));
};
export const getProToken = () => localStorage.getItem(TOKEN_KEY);
export const getProUser = () => {
  try { return JSON.parse(localStorage.getItem(USER_KEY) || "null"); } catch { return null; }
};
export const clearProAuth = () => {
  localStorage.removeItem(TOKEN_KEY);
  localStorage.removeItem(USER_KEY);
};

// Lädt eine PDF authentifiziert und startet den Download (Bearer-Header nötig).
export const downloadProPdf = async (path, filename) => {
  const res = await proApi.get(path, { responseType: "blob" });
  const url = URL.createObjectURL(res.data);
  const a = document.createElement("a");
  a.href = url;
  a.download = filename || "download.pdf";
  document.body.appendChild(a);
  a.click();
  a.remove();
  setTimeout(() => URL.revokeObjectURL(url), 4000);
};
